import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import {
  getGetTipiDomandaQueryOptions,
  getTipiDomanda,
} from '@framework/api-client/api/inquiries/tipi-domanda-controller/tipi-domanda-controller.ts';
import { createAsyncSelectChipValue } from '@framework/form/inputs/AsyncSelectChipValue.tsx';
import {
  AsyncSelectInput,
  type IBaseAsyncSelectInputProps,
} from '@framework/form/inputs/AsyncSelectInput.tsx';

/**
 * Select per tipo domanda utilizzato nel contesto notifiche.
 * Usa l'API admin (`getTipiDomanda`) e mappa `id` → value, `titolo` → label.
 */
export function NotificationInquiryTypeSelectInput(
  props: IBaseAsyncSelectInputProps,
) {
  return (
    <AsyncSelectInput
      {...props}
      queryFn={getTipiDomanda}
      queryOptions={getGetTipiDomandaQueryOptions}
      initialParams={{ ordinamenti: ['titolo'] }}
      searchByField="titolo"
      responseMeta={response => ({
        shown: response?.dati?.length ?? 0,
        total: response?.meta?.totale ?? 0,
      })}
      asOption={(tipoDomanda: TipoDomandaDTO) => ({
        value: tipoDomanda.id ?? '',
        label: tipoDomanda.titolo ?? '',
      })}
    />
  );
}

/** `renderValue` per il chip FilterBar: risolve l'id del tipo domanda (notifiche). */
export const notificationInquiryTypeChipValue = createAsyncSelectChipValue({
  queryFn: getTipiDomanda,
  queryOptions: getGetTipiDomandaQueryOptions,
  initialParams: { ordinamenti: ['titolo'] },
  asOption: (tipoDomanda: TipoDomandaDTO) => ({
    value: tipoDomanda.id ?? '',
    label: tipoDomanda.titolo ?? '',
  }),
});
